import { Injectable } from '@angular/core';
import * as countrycitystatejson from 'country-state-city';

@Injectable({providedIn:"root"})
export class CoutryStateCityService {
  private countryData = countrycitystatejson;

  getCountries() {
    return this.countryData.Country.getAllCountries();
  }

  getStatesByCountry(country: string) {
    return this.countryData.State.getStatesOfCountry(country);
  }

  getCitiesByState(country: string, state: string) {
    return this.countryData.City.getCitiesOfState(country,state);
  }
}